const warehouse = {
  inventoryOrderList: 'Nhập đơn đặt hàng',
  orderNumber: 'Số đơn hàng',
  documentNumber: 'Số chứng từ',
  changeType: 'Loại thay đổi',
  lot: 'Lô',
  quantity: 'Số lượng',
  totalIn: 'Tổng nhập kho',
  totalOut: 'Tổng xuất kho',
  inventory: 'Kiểm kê',
  balance: 'Số dư',
  plSelectProduct: "Vui lòng chọn sản phẩm",
  plProductNum: "Vui lòng nhập số lượng sản phẩm",
  productNumMin: "Số lượng sản phẩm tối thiểu là {{ num }}",
  addProduct: "Thêm thông tin sản phẩm",
  addProductForm: "Điền biểu mẫu {{ name }}",

  inbound: 'Nhập kho',
  outbound: 'Xuất kho',

  deliveryOrderNumber: 'Số đơn hàng giao hàng (nhập kho)',
  materialRequisitionNumber: 'Số đơn yêu cầu vật tư (xuất kho)',

  inboundOprt: 'Tôi muốn nhập kho',
  outboundOprt: 'Tôi muốn xuất kho',
  outboundError: 'Xuất kho thất bại',
  outboundSuccess: 'Xuất kho thành công',
  insufficientInventory: 'Hàng tồn kho không đủ',
  forceOutbound: 'Buộc xuất kho?',
  forceOutboundFailed: 'Buộc xuất kho thất bại',
  inboundError: 'Nhập kho thất bại',
  outboundNotEnough: 'Số lượng hàng tồn kho không đủ',
  returnStock: 'Trả hàng',
  returnStockSuccess: 'Trả hàng thành công',
  returnStockFail: 'Trả hàng thất bại',
  returnQuantity: 'Số lượng trả hàng',
  selectLocationToReturn: 'Chọn vị trí để trả hàng',
  selectLocationToInbound: 'Chọn vị trí nhập kho',
  available: 'Có sẵn',
  returnExceedsAvailable: 'Số lượng trả hàng vượt quá số lượng có sẵn',
  returnExceedsOriginal: 'Số lượng trả hàng vượt quá số lượng đơn hàng gốc {{original}}',
  validationError: 'Xác thực thất bại',
  sourcesPick: 'Lấy vật tư',
  pickingOutbound: 'Xuất kho lấy hàng',
  sourcesInReturn: 'Trả đơn nhập kho',
  sourcesOutReturn: 'Trả đơn xuất kho',

  numDetail: 'Chi tiết nhập số lượng',
  productNum: 'Số lượng sản phẩm',

  arrivalAt: 'Thời gian đến',
  remark: 'Ghi chú',
  enterRemark: 'Vui lòng nhập ghi chú',
  requiredArrivalAt: 'Thời gian đến yêu cầu',
  actualArrivalAt: 'Thời gian đến thực tế',
  plArrivalAt: 'Vui lòng nhập thời gian đến',
  startTime: 'Thời gian bắt đầu',
  endTime: 'Thời gian kết thúc',
  deliveryStartTime: 'Thời gian bắt đầu giao hàng',
  deliveryEndTime: 'Thời gian kết thúc giao hàng',
  plProduct: 'Vui lòng chọn sản phẩm',
  inQuantity: 'Số lượng nhập kho',
  plInQuantity: 'Vui lòng nhập số lượng nhập kho',
  outQuantity: 'Số lượng xuất kho',
  plOutQuantity: 'Vui lòng nhập số lượng xuất kho',
  codeRepeat: 'Mã vạch trùng lặp, vui lòng xóa và thử lại',
  orderType: 'Loại đơn nhập kho',
  inOrder: 'Đơn nhập kho',
  preInOrder: 'Nhập đơn giao hàng (nhập kho trước)',
  purchaseOrder: 'Đơn đặt hàng',
  selectOrderType: 'Vui lòng chọn loại đơn nhập kho',
  selectOrderNumber: 'Vui lòng nhập số đơn nhập kho',
  numberNotExist: 'Số đơn hàng không tồn tại',
  orderConfirmed: "Đơn hàng này đã được xác nhận",
  purchaseNotPass: 'Mua hàng không được phê duyệt',
  saveOrder: 'Lưu đơn nhập kho',
  orderSuccess: 'Nhập kho thành công',
  code: 'Mã vạch',
  existCode: 'Đã tồn tại',
  deleteBarcode: 'Xác nhận xóa mã vạch?',
  deleteBarcodeSuccess: 'Xóa thành công',
  clearCode: 'Xác nhận xóa mã vạch?',
  clear: 'Xóa mã vạch',
  existBarcode: 'Mã vạch đã nhập:',
  outboundType: 'Loại xuất kho',
  inboundType: 'Loại nhập kho',
  preOutOrder: 'Xuất đơn yêu cầu vật tư (xuất kho trước)',
  outSuccess: 'Xuất kho thành công',
  tempIn: 'Nhập kho tạm thời',
  tempOut: 'Xuất kho tạm thời',
  preIn: 'Số lượng nhập kho trước',
  preOut: 'Số lượng xuất kho trước',
  product: 'Sản phẩm',
  salesOrder: 'Đơn bán hàng',
  outOrder: 'Đơn xuất kho',
  specialOutbound: 'Xuất vật tư đặc biệt (danh sách yêu cầu)',
  exportExcel: 'Xuất Excel',
  packingExportConfirm: 'Bạn có chắc chắn muốn xuất danh sách phân loại không?',
  specialMaterialList: 'Danh sách vật tư đặc biệt',
  specialOutSuccess: 'Xuất vật tư đặc biệt thành công',
  specialOutFail: 'Xuất vật tư đặc biệt thất bại',
  normalMaterialList: 'Danh sách kho chung',
  count: 'Số lượng hàng tồn kho',
  thirdPartyBatch: 'Số lô nhà cung cấp',

  inOK: "Nhập kho thành công",
  outOK: "Xuất kho thành công",
  inFail: "Nhập kho thất bại",
  outFail: "Xuất kho thất bại",

  // Quản lý kho
  materialList: 'Danh sách vật tư',
  locationList: 'Danh sách vị trí',
  realMaterialList: "Tồn kho hiện có",
  locationCode: 'Mã vị trí',
  searchMaterialPlaceholder: 'Tìm kiếm mã/tên vật tư',
  searchLocationPlaceholder: 'Tìm kiếm mã vị trí',
  searchBatchPlaceholder: 'Tìm kiếm số lô/số lô nhà cung cấp',
  searchMultiCodePlaceholder: 'Tìm kiếm mã tồn kho (nhiều mã cách nhau bằng khoảng trắng)',
  batchList: 'Danh sách lô',
  materialDetail: 'Chi tiết vật tư',
  lotCount: 'Số lượng lô',
  locationDetail: 'Chi tiết vị trí',
  barcodeList: 'Danh sách mã vạch',
  state: 'Trạng thái',
  lotItemLocationId: 'ID vị trí lô',
  viewBarcode: 'Xem mã vạch',
  batchNo: 'Số lô',
  deliveryBatchNo: 'Số lô giao hàng',
  supplierBatchNo: 'Số lô nhà cung cấp',
  labels: 'Nhãn',
  addLocation: 'Thêm vị trí',
  editLocation: 'Chỉnh sửa vị trí',
  locationIndex: 'Chỉ mục vị trí',
  label1: 'Nhãn 1',
  label2: 'Nhãn 2',
  label3: 'Nhãn 3',
  label4: 'Nhãn 4',
  label5: 'Nhãn 5',
  locationDescPlaceholder: 'Vui lòng nhập mô tả vị trí',
  addLocationSuccess: 'Thêm vị trí thành công',
  addLocationFailed: 'Thêm vị trí thất bại',
  updateLocationSuccess: 'Cập nhật vị trí thành công',
  updateLocationFailed: 'Cập nhật vị trí thất bại',
  l1Required: 'L1 không được để trống',
  l2Required: 'L2 không được để trống',
  l3Required: 'L3 không được để trống',
  l4Required: 'L4 không được để trống',
  l5Required: 'L5 không được để trống',
  l1RequiredFirst: 'Vui lòng điền L1 trước',
  l2RequiredFirst: 'Vui lòng điền L2 trước',
  l3RequiredFirst: 'Vui lòng điền L3 trước',
  l4RequiredFirst: 'Vui lòng điền L4 trước',

  // Cấu hình i18n mới
  location: 'Vị trí',
  locationLabel: 'Nhãn vị trí',
  selectLocation: 'Chọn vị trí',
  searchLocation: 'Tìm kiếm vị trí',
  locationExist: 'Vị trí này đã tồn tại',
  editBarcodes: 'Chỉnh sửa mã vạch',
  fetchError: 'Lấy dữ liệu thất bại',
  barcodesExceedCount: 'Số lượng mã vạch không thể vượt quá số lượng vị trí',
  checkBarcodes: 'Vui lòng kiểm tra mã vạch',
  barcodesExceedNewCount: 'Số lượng mã vạch vượt quá số lượng vị trí mới, vui lòng điều chỉnh mã vạch trước',
  barcodesAutoTrimmed: 'Mã vạch đã tự động bị cắt',
  barcodesAutoTrimmedDesc: 'Số lượng mã vạch vượt quá số lượng vị trí, tự động giữ lại {{count}} mã vạch đầu tiên',
  totalExceedItemCount: 'Tổng số lượng vượt quá giới hạn',
  totalExceedItemCountDesc: 'Tổng số lượng vị trí {{current}} vượt quá số lượng mục đơn hàng {{total}}',
  cannotAddLocation: 'Không thể thêm vị trí',
  totalReachedItemCount: 'Tổng số lượng vị trí đã đạt số lượng mục đơn hàng {{total}}',
  inboundSuccess: 'Nhập kho thành công',
  inboundFailed: 'Nhập kho thất bại',
  quantityMismatch: 'Số lượng không khớp',
  quantityMismatchDesc: 'Tổng số lượng vị trí của các sản phẩm sau không khớp với số lượng đơn hàng:',
  currentTotal: 'Tổng hiện tại',
  requiredTotal: 'Tổng yêu cầu',
  changeLocation: 'Thay đổi vị trí',
  partialInboundSuccess: 'Nhập kho một phần thành công',
  removeOldLocationsFailed: 'Xóa dữ liệu vị trí cũ thất bại',
  barcodeCount: 'Số lượng mã vạch',
  someItemsInboundFailed: 'Một số sản phẩm nhập kho thất bại',
  inboundResultDetail: '{{success}} sản phẩm nhập kho thành công, {{failed}} sản phẩm nhập kho thất bại',
  failedItems: 'Sản phẩm thất bại',
  noBarcodes: 'Không có dữ liệu mã vạch',

  outNo: "Số đơn xuất kho",
  innerNo: "Số đơn nội bộ:",
  outData: "Ngày xuất kho",
  outWare: "Kho xuất hàng",
  llorg: "Bộ phận lấy hàng",
  llper: "Người lấy hàng",
  documentType: "Loại chứng từ",
  outper: "Nhân viên xuất kho",
  inper: "Nhân viên nhập kho",
  wareper: "Quản lý kho",
  outCheckDate: "Ngày kiểm tra",

  returnRn: "Lý do trả hàng: ",
  surplus: "Trả hàng số dư bình thường",
  defective: "Trả hàng lỗi",
  refurbished: "Xử lý hàng lỗi",
  forceReturn: "Xác nhận trả hàng?",
  barcodeErr: "Mã vạch bị lỗi",
  forceInbound: "Buộc nhập kho?",
  forceInboundFailed: "Buộc nhập kho thất bại",
  forcedErr: "Buộc nhập kho thất bại",
  moveLoc: "Di chuyển vị trí",
  targetLocation: "Vị trí đích",
  moveCount: "Số lượng di chuyển",
  maxMoveCount: "Số lượng di chuyển tối đa",
  moveFail: "Di chuyển thất bại",
  moveCurTip: "Vị trí đích không được trùng với vị trí hiện tại",
  pleaseSelectLocation: "Vui lòng chọn vị trí",
  pleaseInputCount: "Vui lòng nhập số lượng",
  countExceedMax: "Số lượng vượt quá giá trị tối đa",
  reoutrecvdpicking: "Lấy hàng xuất kho sai",

  locationIndexExsist: 'Chỉ mục vị trí: {{index}} đã tồn tại',

  // Xuất kho vị trí
  locationOutbound: "Xuất kho vị trí",
  outNum: "Số lượng xuất kho",
  outBarcodes: "Mã vạch xuất kho",
  selectBarcode: "Chọn mã vạch",
  confirmOutboundTip: "Xác nhận xuất kho?",
  confirmOutboundDesc: "Bạn có chắc chắn muốn thực hiện thao tác xuất kho cho lô đã chọn không?",
  inventoryMismatch: "Dữ liệu hàng tồn kho không khớp, vui lòng xác minh lại dữ liệu",

  // Mã vạch và phiếu quét
  unsavedData: "Có dữ liệu chưa được lưu",
  cancelWithoutSave: "Sau khi hủy, dữ liệu không thể khôi phục",
  confirmDeleteBarcode: "Bạn có chắc chắn muốn xóa mã vạch không?",
  deleteCannotRecover: "Sau khi xóa, dữ liệu không thể khôi phục",
  confirmDeleteScanSheet: "Bạn có chắc chắn muốn xóa phiếu quét không?",
  scanSheet: "Phiếu quét",
  completeScanSheetInbound: "Hoàn thành phiếu quét, xác nhận nhập kho",
  barcodesNotInOriginal: "Các mã vạch sau không tồn tại trong danh sách mã vạch gốc: {{barcodes}}",
  barcodeDuplicateInLocations: "Mã vạch {{barcode}} bị trùng trong {{locationCodes}}",

  // Tạo mã vạch
  validationFailed: "Xác thực thất bại",
  dataInvalid: "Dữ liệu không hợp lệ, dữ liệu mỗi phiếu quét không được vượt quá {{max}}",
  generateFailed: "Tạo thất bại",
  maxBarcodeCount: "Đã đạt giới hạn số lượng mã vạch tối đa {{count}}",
  batchGenerateBarcodes: "Tạo hàng loạt mã vạch",
  optional: "Tùy chọn",

  // Trả hàng
  returnStockModal: "Trả hàng",
  orderList: "Danh sách đơn hàng",
  leastOneMove: "Ít nhất một lô có số lượng di chuyển lớn hơn 0",
  confirmPreOut: "Xác nhận thực hiện xuất kho trước?",
  sign: "Ký nhận",
  signed: "Đã ký nhận",
  signSucc: "Ký nhận thành công",
  signFail: "Ký nhận thất bại",
  plSignDate: "Chọn ngày ký nhận",
  productRef: "Giới thiệu sản phẩm",
  selectProduct: "Chọn sản phẩm",
  productExists: "Sản phẩm đã tồn tại",
  addLocationRef: "Thêm liên kết vị trí sản phẩm",
  confirmBatchDelete: "Bạn có chắc chắn muốn xóa hàng loạt các liên kết vị trí sản phẩm đã chọn không?",
  confirmDeleteItem: "Bạn có chắc chắn muốn xóa liên kết vị trí sản phẩm này không?",
  allocatePreOut: "Phân bổ xuất kho trước",
  allocatePreOutSuccess: "Phân bổ xuất kho trước thành công",
  allocatePreOutFail: "Phân bổ xuất kho trước thất bại",

  // Nhập thủ công liên quan
  manualInbound: "Nhập thủ công",
  complete: "Hoàn thành",
  delete: "Xóa",
  productCode: "Mã sản phẩm",
  productName: "Tên sản phẩm",
  productModel: "Mô hình sản phẩm",
  uom: "Đơn vị",
  noData: "Không có dữ liệu",
  previous: "Trước",
  next: "Tiếp",
  confirm: "Xác nhận",
  notRecommendedLocation: "Vị trí đã chọn không phải là vị trí được giới thiệu",
  isNotRef: "Vị trí kho này không phải là vị trí đề xuất",
  recommendedLocations: "Vị trí được giới thiệu",
  allLocations: "Tất cả vị trí",
  locationsRequired: "Vui lòng thêm vị trí cho mỗi sản phẩm",
  locationCountRequired: "Số lượng vị trí không được để trống hoặc bằng 0",
  inboundComplete: "Hoàn thành nhập kho",
  inboundSuccessDesc: "Thao tác nhập kho đã hoàn thành thành công",
  otherOut: "Xuất kho khác",
  outNumNotZ: "Số lượng xuất kho không thể bằng 0",
  outNumExceedStock: "Số lượng xuất kho vượt quá tồn kho khả dụng",
  productInput: "Nhập vật liệu",
  locNumnotOrder: "Tổng số lượng vị trí kho không bằng số lượng nhập kho, vui lòng sửa lại",
  outOvernum: "Số lượng xuất kho vượt quá {{num}} cái",
  outLossnum: "Số lượng xuất kho thiếu {{num}} cái",
  outboundLocationError: "Các vật liệu sau không có vị trí xuất kho",
  outboundCountMismatch: "Số lượng xuất kho của các vật liệu sau không bằng số lượng cần xuất, vui lòng sửa lại dữ liệu",
  noStock: "Không có tồn kho",
  delOutTip: "Đơn xuất kho dự kiến {{number}} đã được tạo. Bạn có muốn xóa không?",
  inputer: "Người tạo đơn",
  confirmer: "Người xác nhận",
  locFailed: "Thông tin vị trí kho không khớp với thông tin đơn hàng. Vui lòng kiểm tra lại.",
  reMatchTip: "Xác nhận xuất kho thất bại, cần khớp lại tồn kho",
  reMatchSucc: "Vị trí kho đã được phân bổ lại, dữ liệu đã được cập nhật",
  reMatchFail: "Khớp lại tồn kho thất bại",
  delInTip: "Đơn nhập kho dự kiến {{number}} đã được tạo. Bạn có muốn xóa không?",
  delInSucc: "Đơn nhập kho dự kiến {{number}} đã tạo thành công",
  inboundUpdateSucc: "Dữ liệu đơn nhập kho dự kiến đã được cập nhật",
  delOrderClose: "Xóa đơn hàng",
  notDelClose: "Giữ lại đơn hàng",
  needPrefit: 'Kiểm tra trước thất bại. Thông tin lô xuất kho dưới đây cần được sửa.',
  needSucc: 'Kiểm tra trước thành công. Dữ liệu xuất kho không cần sửa.',
  needFail: 'Kiểm tra trước thất bại. Không thể lấy thông tin tồn kho.',
  outPrefit: 'Kiểm tra trước xuất kho',
  fixOut: 'Sửa xuất kho',
  fixSucc: 'Sửa thông tin xuất kho thành công!',
  fixFail: 'Sửa thông tin xuất kho thất bại!',
  outQtyErr: 'Lỗi phân bổ số lượng xuất kho!',
  fetchStockError: 'Lấy tồn kho thất bại!',
  oldItemInfo: 'Thông tin xuất kho gốc',
  returnInfo: 'Thông tin đơn trả kho',
  delReturnClose: "Đơn trả kho {{number}} đã được tạo. Bạn có muốn xóa không?",
  confirmReturnTip: "Xác nhận trả kho?",
  returnNumber: "Số đơn trả kho",
  noUseStock: "Không có tồn kho khả dụng",
  noLotStock: "Không có tồn kho cho lô trả kho này: {{lot}}",
  noCodeStock: "Không có tồn kho cho vật liệu này: {{code}}",
  returnLot: "Lô trả kho",
  needFix: "Xác nhận xuất kho thất bại. Vui lòng kiểm tra trước, sửa thông tin hoặc cấp phát lại tồn kho.",
  rePreout: "Cấp phát lại tồn kho",
  orderCount: "Số lượng xuất kho lần này",
  useAmtReq: "Tổng số lượng yêu cầu",
  pickingOutbound_m: "Xuất kho nguyên vật liệu",
  productOldCount: "Số lượng vật liệu trước xác nhận",
  productNewCount: "Số lượng vật liệu sau xác nhận",
  lotItemOldCount: "Số lượng lô trước xác nhận",
  lotItemNewCount: "Số lượng lô sau xác nhận",
  noconf: "Chưa xác nhận",
  confed: "Đã xác nhận",
  plconfed: "Đã xác nhận chưa?",
  refNo: "Số tham chiếu",
  proIn: "Nhập kho sản xuất",
  locProNot: "Tồn kho không đủ: Vị trí: {{locIdx}}, Vật liệu {{proCode}}",
  signTime: "Thời gian ký nhận",
  prodTempIn: "Nhập kho sản xuất (tạm thời)",
  iqcState: "Trạng thái kiểm tra chất lượng",
  notIqc: "Chưa kiểm tra",
  iqcEd: "Đã kiểm tra",
  iqcCheck: "Kiểm tra IQC",
  iqcList: "Danh sách đơn kiểm tra IQC",
  iqcNumber: "Số đơn kiểm tra",
  iqcInventory: "Số đơn nhập/xuất",
  iqcType: "Loại kiểm tra",
  iqcUser: "Người kiểm tra",
  iqcRes: "Kết quả kiểm tra",
  iqcTime: "Thời gian kiểm tra",
  toQc: "Chờ kiểm tra",
  qcIng: "Đang kiểm tra",
  passQc: "Đạt",
  failQc: "Không đạt",
  front: "Lỗi bề ngoài",
  size: "Lỗi kích thước",
  power: "Lỗi hiệu suất",
  package: "Lỗi bao bì",
  tag: "Lỗi nhãn mác",
  other: "Khác",
  dispReturn: "Trả hàng",
  dispAcpt: "Chấp nhận nhượng bộ",
  dispRedo: "Làm lại",
  qcInbound: "Kiểm tra nhập kho",
  qcOutbound: "Kiểm tra xuất kho",
  qcWarehouse: "Kiểm tra tồn kho",
  qcProgress: "Kiểm tra quy trình",
  qcReturn: "Kiểm tra trả hàng",
  typePl: "Vui lòng chọn loại kiểm tra",
  statePl: "Vui lòng chọn trạng thái kiểm tra",
  fetchErr: "Lấy đơn kiểm tra thất bại!",
  createdAt: "Thời gian tạo đơn",
  creator: "Người tạo đơn",
  desc: "Ghi chú kiểm tra",
  qcItems: "Hạng mục kiểm tra",
  checkCount: "Số lượng kiểm tra",
  passCount: "Số lượng đạt",
  failCount: "Số lượng không đạt",
  qcResult: "Kết quả kiểm tra",
  defectType: "Loại lỗi",
  disposition: "Kết quả xử lý",
  doc: "Tệp đính kèm kiểm tra",
  remarks: "Ghi chú",
  qcItemList: "Danh sách vật liệu kiểm tra",
  addQc: "Thêm đơn kiểm tra QC",
  qcOrder: "Đơn kiểm tra",
  selectInventory: "Chọn đơn nhập/xuất",
  writeQc: "Nhập thông tin kiểm tra",
  itemCount: "Số lượng đơn hàng",
  descPl: "Nhập ghi chú kiểm tra",
  checkCountPl: "Nhập số lượng kiểm tra",
  passCounPl: "Nhập số lượng đạt",
  failCountPl: "Nhập số lượng không đạt",
  qcResultPl: "Chọn kết quả kiểm tra",
  defectTypePl: "Chọn loại lỗi",
  dispositionPl: "Chọn kết quả xử lý",
  qcTyePl: "Chọn loại kiểm tra",
  add: "Tạo đơn kiểm tra",
  addErr: "Tạo đơn kiểm tra thất bại, không có dữ liệu",
  addErr1: "Tạo đơn kiểm tra thất bại",
  done: "Hoàn thành",
  doneTip: "Đơn kiểm tra {{number}} đã được tạo thành công!",
  itemDesc: "Vui lòng nhập ghi chú cho hạng mục kiểm tra",
  noUpdate: "Không có dữ liệu cập nhật, không cần lưu",
  updateSucc: "Lưu thành công",
  havePass: "Đã đạt",
  notPass: "Đạt thất bại!",
  hasUpdata: "Có thay đổi chưa lưu. Lưu trước khi đạt?",
  canNotPass: "Hoàn thành thất bại",
  canNotPassTip: "Vui lòng đảm bảo tất cả hạng mục kiểm tra đều có kết quả",
  qcDone: "Đã hoàn thành kiểm tra {{number}}",
  reQc: "Kiểm tra lại",
  doneQC: "Hoàn thành kiểm tra",
  optSucc: "Thao tác thành công",
  optFail: "Thao tác thất bại",
  canAddQc: "Có thể tiếp tục thêm đơn kiểm tra",
  orderQcDone: "Đơn nhập/xuất: {{number}} đã hoàn thành kiểm tra [{{res}}]",
  normalPrint: "Phân trang ngang",
  verticalPrint: "Liên tục dọc",
  manual: "Thủ công",
  production: "Sản xuất",
  purchase: "Mua hàng",
  sale: "Bán hàng",
  dispose: "Điều chuyển",
  sourceType: "Loại",
  packing: "Phân loại trong kho",
  packingNo: "Số phiếu phân loại",
  perBoxQuantity: "Số lượng/thùng",
  perBoxNetWeight: "Khối lượng tịnh/thùng",
  perBoxGrossWeight: "Khối lượng cả bì/thùng",
  totalQuantity: "Số lượng",
  totalNetWeight: "Khối lượng tịnh",
  totalGrossWeight: "Khối lượng cả bì",
  measurements: "Kích thước",
  packingVolume: "Thể tích",
  draft: "Nháp",
  confirmed: "Đã xác nhận",
  shuted: "Đã niêm phong",
  wasted: "Đã hủy",
  packStatus: "Trạng thái phân loại",
  totalBoxes: "Số thùng",
  grossWeight: "Trọng lượng gộp",
  netWeight: "Trọng lượng tịnh",
  totalVolume: "Thể tích",
  delTip: "Bạn có chắc chắn muốn hủy phiếu phân loại: {{no}}?",
  addPack: "Thêm phiếu phân loại",
  inventoryPl: "Vui lòng chọn đơn xuất kho",
  inventoryInPl: "Vui lòng chọn đơn nhập kho",
  orderPl: "Vui lòng chọn đơn nhập/xuất kho",
  packDtl: "Chi tiết phiếu phân loại",
  closeBox: "Niêm phong",
  openBox: "Mở niêm phong",
  killed: "Hủy bỏ",
  confirmSucc: "Xác nhận thành công",
  confirmFail: "Xác nhận thất bại",
  sealSucc: "Niêm phong thành công",
  sealFail: "Niêm phong thất bại",
  unSealSucc: "Mở niêm phong thành công",
  unSealFail: "Mở niêm phong thất bại",
  wasteFail: "Hủy bỏ thất bại",
  items: "Hạng mục sản phẩm",
  boxes: "Chi tiết phân loại",
  boxNo: "Số thùng",
  boxBarcode: "Mã vạch thùng",
  lengthMm: "Dài (cm)",
  widthMm: "Rộng (cm)",
  heightMm: "Cao (cm)",
  volumeCbm: "Thể tích (cm³)",
  grossWeightG: "Trọng lượng gộp (kg)",
  netWeightG: "Trọng lượng tịnh (kg)",
  packageType: "Loại bao bì",
  marksNumbers: "Ký mã hiệu",
  delBoxTip: "Bạn có chắc chắn muốn xóa: {{no}}?",
  addBox: "Thêm thùng",
  editBox: "Sửa thùng {{no}}",
  boxAddItem: "Phân loại",
  boxedCount: "Số lượng đã phân loại",
  plItem: "Vui lòng chọn hạng mục phân loại",
  boxEditItem: "Sửa thông tin phân loại",
  boxItemQty: "Số lượng phân loại",
  declaredUnitPrice: "Đơn giá",
  declaredCurrency: "Loại tiền tệ",
  hsCode: "Mã HS",
  originPlace: "Xuất xứ",
  productNameCn: "Tên tiếng Trung",
  productNameEn: "Tên tiếng Anh",
  brand: "Thương hiệu",
  brandType: "Loại thương hiệu",
  packingModel: "Mẫu mã",
  packingOrigin: "Xuất xứ",
  exportBrandName: "Tên thương hiệu xuất khẩu",
  declaredAmount: "Tổng giá",
  shutErr: "Niêm phong thất bại",
  weightNeed: "Vui lòng nhập trọng lượng gộp và trọng lượng tịnh",
  shipmentOut: "Xuất hàng",
  noShipment: "Không tìm thấy lô hàng",
  noOrder: "Không tìm thấy đơn hàng",
  outItems: "Chi tiết xuất kho",
  plPreLOcTypes: "Vui lòng chọn loại vị trí khớp xuất kho",
  shipOutData: "Dữ liệu xuất hàng",
  outDone: "Xuất kho hoàn tất",
  noBox: "Không có thùng hoặc thùng rỗng!",
  needPre: "Vui lòng phân bổ tồn kho cho đơn xuất kho trước",
  selectSaleOrder: "Chọn đơn bán hàng",
  noOutOrder: "Không có đơn xuất kho",
  noOutOrderTip: "Không có đơn xuất kho đã xác nhận",
  outOrderFail: "Tải đơn xuất kho thất bại",
  selectOutOrder: "Chọn đơn xuất kho",
  remainPack: "Số lượng phân loại còn lại",
  selectLot: "Chọn lô",
  genShip: "Tạo đơn giao hàng",
  searchCode: "Tìm mã vật liệu",
  plSelBox: "Vui lòng chọn các thùng cần giao hàng",
  plInQuantityLot: "Vui lòng nhập số lượng nhập kho và lot",
  packOrder: "Phiếu phân loại",
  toClose: "Chờ niêm phong",
  gWeightNeed: "Vui lòng nhập trọng lượng gộp",
  addOutOrder: "Thêm đơn xuất kho",
  sealAllTip: "Tất cả các thùng trong phiếu phân loại đã được niêm phong. Sau khi xác nhận, toàn bộ đơn hàng sẽ tự động niêm phong.",
  emptyBox: "Thùng rỗng: {{number}}",
  selectCustomer: "Chọn khách hàng",
  selectCustomerPl: "Vui lòng chọn khách hàng",
  multiBox: "Nhập nhiều thùng",
  addingTip: "Vui lòng nhập số lượng thùng (bao gồm thùng hiện tại)",
  addPackQty: "Số thùng",
  newBoxNumber: "Số thùng mới",
  selBoxErr: "Mục chọn không hợp lệ",
  selBoxErrTip1: "Chỉ có thể chọn thùng đã đóng và chưa tạo đơn giao hàng",
  selBoxErrTip2: "Không thể chọn thùng rỗng hoặc thùng đã niêm phong",
  selBoxErrTip3: "Các thùng sau đã bị lọc",
  batchSeal: "Niêm phong hàng loạt",
  plBatchSeal: "Vui lòng chọn thùng cần niêm phong",
  batchGross: "Áp dụng trọng lượng gộp hàng loạt (sau khi chọn, trọng lượng gộp của tất cả thùng hiện tại sẽ được cập nhật đồng bộ)",
  batchSealSucc: "Niêm phong hàng loạt thành công",
  batchSealErr: "Niêm phong hàng loạt thất bại",
  editBoxErr: "Sửa trọng lượng thùng thất bại, Số thùng: {{number}}",
  sealBoxErr: "Niêm phong thất bại, Số thùng: {{number}}",
  filterdSeal: "Thùng đã niêm phong và thùng rỗng đã bị bỏ qua",
  noSealBox: "Không có thùng nào có thể niêm phong",
  sealRange: "Phạm vi niêm phong",
  boxNoPl: "Vui lòng nhập số thùng",
  reset: "Đặt lại",
  startNo: "Số thùng bắt đầu",
  endNo: "Số thùng kết thúc",
  searchRange: "Phạm vi tìm kiếm",
  productType: "Loại sản phẩm",
};

export default warehouse;
